import { useNavigate } from '@tanstack/react-router'
import { ArrowUpCircleIcon } from 'lucide-react'

export const ViewPlan: React.FC = () => {
  const navigate = useNavigate()

  return (
    <button
      className="flex"
      onClick={() => {
        void navigate({ to: '/pricing' })
      }}
    >
      <div className="flex space-x-4 rounded-md bg-accent p-2 pr-6">
        <ArrowUpCircleIcon className="text-blue-700" size={20} />
        <div className="flex flex-col items-start">
          <div className="text-sm">View plans</div>
          <div className="text-xs text-blue-900">Upgrade for premium features.</div>
        </div>
      </div>
    </button>
  )
}
